import client from './main-client';

export const getCollaboratorsApi = (params) => client().get('/collaborators', { params });
export const updateCollaboratorsApi = (params) => client().put(`/collaborators/${params.id}`, params);
export const addCollaboratorsApi = (data) => client().post('/collaborators', data);
export const deleteCollaboratorsApi = (params) => client().delete(`/collaborators/${params.id}`);
